import {
    useState,
    useEffect,
    useMemo,
} from "react";

import useResponsive from "@/hooks/useResponsive";
import { useParams, useNavigate } from "react-router-dom";
import apiClient from "../utils/apiClient";
import serviceService from "../services/serviceService";
import Accounting from "./Accounting";
import TripTransportOperations from "../components/TripTransportOperations";
import AddFollowUpModal from "../components/AddFollowUpModal";
import ReassignQueryModal from "../components/ReassignQueryModal";
import { useAuth } from "../context/AuthContext";
import "./TripDetailView.css";
import { socket } from "../config/socket";
import {
    sortServices,
    mergeServiceUpdate,
    reorderServicesLocally,
} from "../utils/serviceState";
import {
    Dropdown,
    Modal,
    DatePicker,
    Input,
} from "antd";
import { EllipsisOutlined } from "@ant-design/icons";
import SuggestedQuotesSection from "../modules/quotation/components/SuggestedQuotesSection";
import {
    duplicateQuotation,
    cancelQuotation,
    archiveQuotation,
    downloadQuotationPdf,
    convertQuotationToBooking,
} from "../services/quotationService";

const serviceCard = {
    background: "#fff",
    border: "1px solid #eee",
    borderRadius: 10,
    padding: 16,
    boxShadow: "0 1px 4px rgba(0,0,0,0.04)",
};

const TripDetailView = () => {
 const { id: leadId } = useParams();
    const navigate = useNavigate();
    const { user } = useAuth();
    const { isMobile } = useResponsive();

    const [showReassignModal, setShowReassignModal] = useState(false);

    const [showLeadEdit, setShowLeadEdit] = useState(false);
    const [leadEditForm, setLeadEditForm] = useState({
        customerName: "",
        email: "",
        phone: "",
        travelDate: "",
        duration: "",
        destination: "",
        destinations: [],
        adults: 1,
        children: 0,
        infants: 0,
    });
    const [savingLead, setSavingLead] = useState(false);
    const [destinations, setDestinations] = useState([]);

    const defaultTab = useMemo(() => {
        const params = new URLSearchParams(window.location.search);
        return params.get("tab") || "bookings";
    }, []);

    const [activeTab, setActiveTab] = useState(defaultTab);
    const [creatingActivity, setCreatingActivity] = useState(false);
    const [lead, setLead] = useState(null);
    const [quotes, setQuotes] = useState([]);
    const [suggestedQuotes, setSuggestedQuotes] = useState([]);
    const [showPaymentModal, setShowPaymentModal] = useState(false);
    const [selectedQuote, setSelectedQuote] = useState(null);
const [paymentForm, setPaymentForm] = useState({
    paymentType: "partial",
    amount: "",
    paymentMode: "upi",
    utrNumber: "",
    comments: ""
});

const [followUpModalOpen, setFollowUpModalOpen] = useState(false);

const [followUpNote, setFollowUpNote] = useState("");

const [followUpDate, setFollowUpDate] = useState(null);

const [showInstallmentModal, setShowInstallmentModal] = useState(false);

const [installmentForm, setInstallmentForm] = useState({
    title: "",
    amount: "",
    dueDate: "",
    notes: ""
});

const [showEditModal, setShowEditModal] =
    useState(false);

const [editingInstallment, setEditingInstallment] =
    useState(null);

const [editForm, setEditForm] = useState({

    title: "",

    amount: "",

    dueDate: "",

    notes: "",

    status: "pending",

});
    
const [bookingId, setBookingId] = useState(null);
    const [services, setServices] = useState([]);

    const groupedServices = useMemo(() => {
        return Object.values(
            (services || []).reduce((acc, service) => {
                if (!service?._id) return acc;
                const key = service.location?.city?.trim() || "Other";
                if (!acc[key]) acc[key] = { city: key, items: [] };
                acc[key].items.push(service);
                return acc;
            }, {})
        );
    }, [services]);

    const serviceStats = useMemo(() => {
        const confirmed = services.filter(
            (s) => s.status === "confirmed" || s.status === "booked"
        ).length;
        const vouchers = services.filter((s) => s.voucher?.sent === true).length;
        return { total: services.length, confirmed, vouchers };
    }, [services]);

    const [servicesLoading, setServicesLoading] = useState(false);
    const [newService, setNewService] = useState({
        type: "hotel",
        title: "",
        startDate: "",
        endDate: "",
        sellingPrice: "",
    });
    const [addingService, setAddingService] = useState(false);
    const [documents, setDocuments] = useState([]);
    const [activities, setActivities] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    // Loading states for each tab
    const [quotesLoading, setQuotesLoading] = useState(false);
    const [documentsLoading, setDocumentsLoading] = useState(false);    const [activitiesLoading, setActivitiesLoading] = useState(false);
    const [booking, setBooking] = useState(null);

useEffect(() => {
  fetchLeadDetails();
  fetchExistingBooking();
  fetchSuggestedQuotes();
  fetchDestinations();
  fetchActivities();
}, [leadId]);

    const fetchLeadDetails = async () => {
        console.log("leadId:", leadId);
        if (!leadId) {
            setError("Invalid lead ID");
            setLoading(false);
            return;
        }
        try {

const response = await apiClient.get(`/leads/${leadId}`);

console.log("========== RAW RESPONSE ==========");
console.log(response);


const leadData = response.data?.data || response.data;

console.log("========== LEAD DATA ==========");
console.log(leadData);

setLead(leadData);

const initialDests = Array.isArray(leadData.destinations) && leadData.destinations.length
    ? leadData.destinations.map(d => d._id || d)
    : (leadData.destination?._id || leadData.destination ? [leadData.destination?._id || leadData.destination] : []);

setLeadEditForm({
    customerName: leadData.customerName || "",
    email: leadData.email || "",
    phone: leadData.phone || "",
    destination:
        leadData.destination?._id ||
        leadData.destination ||
        "",
    destinations: initialDests,
    travelDate: leadData.travelDate
        ? leadData.travelDate.slice(0, 10)
        : "",
    duration: leadData.duration || 0,
    adults: leadData.pax?.adults ?? 1,
    children: leadData.pax?.children ?? 0,
    infants: leadData.pax?.infants ?? 0,
});

setLoading(false);

        } catch (err) {
            console.error("Error fetching lead details:", err);
            setError(err.response?.data?.message || "Failed to load lead details");
            setLoading(false);
        }
    };

    const fetchDestinations = async () => {
        try {
            const res = await apiClient.get("/destinations");
            setDestinations(res.data?.data || []);
        } catch (err) {
            console.error("Failed loading destinations:", err);
        }
    };

const fetchExistingBooking = async () => {
    try {
        if (!leadId) return;

        const res = await apiClient.get("/bookings", {
            params: { leadId }
        });

        const list = res.data?.data || [];

        const b = list.find(
            (booking) =>
                String(
                    booking.leadId?._id || booking.leadId
                ) === String(leadId)
        );

        if (!b) return;

        const bookingRes = await apiClient.get(
            `/bookings/${b._id}`
        );

        setBookingId(bookingRes.data.data._id);
        setBooking(bookingRes.data.data);

    } catch (err) {
        console.error("Error fetching booking:", err);
    }
};

    const fetchQuotes = async () => {
        setQuotesLoading(true);
        try {
            const response = await apiClient.get(`/quotations`, { params: { leadId } });
            setQuotes(response.data?.data || []);
        } catch (err) {
            console.error("Error fetching quotes:", err);
            setError("Failed to load quotes");
        } finally {
            setQuotesLoading(false);
        }
    };

    const fetchSuggestedQuotes = async () => {
        try {
            const response = await apiClient.get(`/quotations/suggestions/${leadId}`);
            setSuggestedQuotes(response.data?.data || []);
        } catch (err) {
            console.error("Suggestions fetch failed:", err);
        }
    };

    const fetchServices = async () => {
        if (!bookingId) return; // 🔥 STOP AUTO CREATE
        setServicesLoading(true);
        try {

const data = await serviceService.getByBooking(bookingId);

setServices(sortServices(data || []));

        } catch (err) {
            console.error("Error fetching services:", err);
            setError("Failed to load services");
        } finally {
            setServicesLoading(false);
        }
    };

    const refreshBooking = async () => {
        if (!bookingId) return;
        try {
            const res = await apiClient.get(`/bookings/${bookingId}`);
            setBooking(res.data?.data || null);
        } catch (err) {
            console.error("Refresh booking failed:", err);
        }
    };

    useEffect(() => {
        if (bookingId) fetchServices();
    }, [bookingId]);

    useEffect(() => {
        if (!bookingId) return;
        if (!socket.connected) socket.connect();
        socket.emit("join_booking", bookingId);

        const handleServiceUpdated = ({ service }) => {
            if (!service?._id) return;
            setServices((prev) => {
                const exists = prev.some((s) => String(s._id) === String(service._id));
                if (!exists) return sortServices([...prev, service]);
                return mergeServiceUpdate(prev, service);
            });
        };

        const handleServiceDeleted = ({ serviceId }) => {
            setServices((prev) => prev.filter((s) => String(s._id) !== String(serviceId)));
        };

        const handleServiceReordered = ({ updates }) => {
            if (!Array.isArray(updates)) return;
            setServices((prev) => reorderServicesLocally(prev, updates));
        };

        const handleBookingUpdated = (payload) => {
            const updatedBooking = payload?.booking;
            // 🔒 SAFETY CHECKS
            if (!updatedBooking?._id) return;
            setBooking((prev) => ({ ...(prev || {}), ...updatedBooking }));
        };

        socket.off("service:updated");
        socket.off("service:deleted");
        socket.off("service:reordered");
        socket.off("booking:updated");
        socket.on("service:updated", handleServiceUpdated);
        socket.on("service:deleted", handleServiceDeleted);
        socket.on("service:reordered", handleServiceReordered);
        socket.on("booking:updated", handleBookingUpdated);

        return () => {
            socket.emit("leave_booking", bookingId);
            socket.off("service:updated", handleServiceUpdated);
            socket.off("service:deleted", handleServiceDeleted);
            socket.off("service:reordered", handleServiceReordered);
            socket.off("booking:updated", handleBookingUpdated);
        };
    }, [bookingId]);


    const fetchDocuments = async () => {
        setDocumentsLoading(true);
        try {
            const response = await apiClient.get(`/bookings/${bookingId}/documents`);
            setDocuments(response.data?.data || []);
        } catch (err) {
            console.error("Error fetching documents:", err);
            setError("Failed to load documents");
        } finally {
            setDocumentsLoading(false);
        }
    };

    const fetchActivities = async () => {
        setActivitiesLoading(true);
        try {
            const response = await apiClient.get(`/activities/lead/${leadId}`);
            setActivities(response.data?.data || []);
        } catch (err) {
            console.error("Error fetching activities:", err);
            setError("Failed to load activities");
        } finally {
            setActivitiesLoading(false);
        }
    };

const handleAddActivity = async () => {

    setFollowUpModalOpen(true);

};

const saveFollowUp = async () => {

    if (!followUpNote.trim()) {
        return;
    }

    if (!followUpDate) {
        return;
    }

    try {

        setCreatingActivity(true);

        await apiClient.put(
            `/leads/${leadId}`,
            {
                lastFollowUp: {
                    date: new Date(),
                    notes: followUpNote.trim(),
                    nextFollowUp: followUpDate.format("YYYY-MM-DD"),
                },
            }
        );

        await apiClient.post("/activities", {
            leadId,
            type: "follow_up",
            message: followUpNote.trim(),
        });

        await fetchLeadDetails();
        await fetchSuggestedQuotes();        
        await fetchActivities();

        setFollowUpModalOpen(false);
        setFollowUpNote("");
        setFollowUpDate(null);

        alert("Follow up saved successfully");

    } catch (err) {

        console.error(err);

        alert(
            err?.response?.data?.message ||
            "Failed to save follow up"
        );

    } finally {

        setCreatingActivity(false);

    }
};

    const handleTabChange = (tab) => {
        setActiveTab(tab);
        if (tab === "quotes" && quotes.length === 0) fetchQuotes();
        if (tab === "docs" && documents.length === 0) fetchDocuments();
        if (tab === "activities" && activities.length === 0) fetchActivities();
        if (tab === "operations" && bookingId) refreshBooking();
    };

const handleDuplicateQuote = async (quote) => {
    try {
        const res = await duplicateQuotation(
            quote._id
        );

        const newQuote =
            res?.data?.data;

        if (!newQuote?._id) {
            throw new Error(
                "Duplicate failed"
            );
        }

        navigate(
            `/quotation-builder/edit/${newQuote._id}`
        );

    } catch (err) {
        console.error(err);

        alert(
            err?.response?.data?.message ||
            "Failed to duplicate quote"
        );
    }
};

const handleArchiveQuote = async (quote) => {
    try {

        await archiveQuotation(
            quote._id
        );

        await fetchQuotes();

        alert(
            "Quote archived"
        );

    } catch (err) {

        console.error(err);

        alert(
            err?.response?.data?.message ||
            "Archive failed"
        );
    }
};

const handleCancelQuote = async (quote) => {

    try {

        await cancelQuotation(
            quote._id
        );

        await fetchQuotes();

        alert(
            "Quote cancelled"
        );

    } catch (err) {

        console.error(err);

        alert(
            err?.response?.data?.message ||
            "Cancel failed"
        );
    }
};

const handleDownloadQuote = async (quote) => {

    try {

        const response =
            await downloadQuotationPdf(
                quote._id
            );

        const blob =
            new Blob(
                [response.data],
                {
                    type: "application/pdf",
                }
            );

        const url =
            window.URL.createObjectURL(
                blob
            );

        const a =
            document.createElement("a");

        a.href = url;

        a.download =
            `${quote.quotationNumber || quote.quoteNumber || "quotation"}.pdf`;

        a.click();

        window.URL.revokeObjectURL(
            url
        );

    } catch (err) {

        console.error(err);

        alert(
            "Download failed"
        );
    }
};

const handleConvertToBooking = async (quote) => {

    try {

        const res =
            await convertQuotationToBooking(
                quote._id
            );

        alert(
            res?.data?.message ||
            "Trip created successfully"
        );

        await fetchExistingBooking();
        await fetchQuotes();

        setActiveTab("bookings");

    } catch (err) {

        console.error(err);

        alert(
            err?.response?.data?.message ||
            "Conversion failed"
        );
    }
};

const handleLogPayment = async () => {

    if (!selectedQuote?._id) {
        alert("Please select a quotation");
        return;
    }

    try {

await apiClient.post(
    `/accounting/leads/${leadId}/payments`,
    {
        bookingId,

        quotationId: selectedQuote._id,

        amount: Number(paymentForm.amount),

        paymentType: "partial",

        paymentMode: paymentForm.paymentMode,

        utrNumber: paymentForm.utrNumber,

        comments: paymentForm.comments
    }
);

        await fetchQuotes();

        await fetchExistingBooking();

        setShowPaymentModal(false);

        setPaymentForm({
            paymentType: "partial",
            amount: "",
            paymentMode: "upi",
            utrNumber: "",
            comments: ""
        });

        alert("Payment logged");

    } catch (err) {

        console.error(err);

        alert(
            err?.response?.data?.message ||
            "Payment logging failed"
        );
    }
};   

const handleAddInstallment = async () => {

    try {

const balance =
    booking?.financials?.balanceDue || 0;

if (
    Number(installmentForm.amount) >
    balance
) {
    alert(
        "Installment amount cannot exceed outstanding balance."
    );
    return;
}

        await apiClient.post(
            `/bookings/${bookingId}/payment-schedule`,
            {
                title: installmentForm.title,
                amount: Number(installmentForm.amount),
                dueDate: installmentForm.dueDate,
                notes: installmentForm.notes
            }
        );

        await fetchExistingBooking();

        await fetchQuotes();

        setShowInstallmentModal(false);

        setInstallmentForm({
            title: "",
            amount: "",
            dueDate: "",
            notes: ""
        });

    } catch (err) {

        console.error(err);

        alert(
            err?.response?.data?.message ||
            "Unable to add installment"
        );
    }
};

const handleEditInstallment = (item) => {

    setEditingInstallment(item);

    setEditForm({

        title:
            item.title || "",

        amount:
            item.amount || "",

        dueDate:
            item.dueDate
                ? new Date(item.dueDate)
                    .toISOString()
                    .split("T")[0]
                : "",

        notes:
            item.notes || "",

        status:
            item.status || "pending",

    });

    setShowEditModal(true);

};

const handleSaveInstallment = async () => {

    try {

        await apiClient.put(

            `/bookings/${bookingId}/payment-schedule/${editingInstallment._id}`,

            {

                title:
                    editForm.title,

                amount:
                    Number(editForm.amount),

                dueDate:
                    editForm.dueDate,

                notes:
                    editForm.notes,

                status:
                    editForm.status,

            }

        );

        await fetchExistingBooking();

        setShowEditModal(false);

        setEditingInstallment(null);

    }

    catch (err) {

        console.error(err);

        alert(

            err?.response?.data?.message ||

            "Failed to update installment"

        );

    }

};

const handleDeleteInstallment = async (item) => {

    if (

        !window.confirm(

            "Delete this installment?"

        )

    ) {

        return;

    }

    try {

        await apiClient.delete(

            `/bookings/${bookingId}/payment-schedule/${item._id}`

        );

        await fetchExistingBooking();

    }

    catch (err) {

        console.error(err);

        alert(

            err?.response?.data?.message ||

            "Delete failed"

        );

    }

};

 const handleCreateService = async () => {
        try {
            if (!bookingId) { alert("Convert to Trip first"); return; }
            const payload = {
                bookingId,
                type: "hotel",
                title: newService.title,
                startDate: newService.startDate,
                endDate: newService.endDate,
                location: {
                    city:
                        lead?.destination?.city ||
                        lead?.destination?.name ||
                        (typeof lead?.destination === "string" ? lead.destination : "Other"),
                },
                pricing: { cost: Number(newService.sellingPrice || 0) },
            };
            const response = await serviceService.create(payload);
            const created = response?.data || response;
            if (!created?._id) throw new Error("Invalid service response");
            setServices((prev) => {
                const exists = prev.some((s) => String(s._id) === String(created._id));
                if (exists) return prev;
                return mergeServiceUpdate(prev, created);
            });
            setAddingService(false);
            setNewService({ type: "hotel", title: "", startDate: "", endDate: "", sellingPrice: "" });
        } catch (err) {
            console.error(err);
            alert("Service creation failed");
        }
    };

const generateServiceVoucher = async () => {
    try {

        const res = await apiClient.get(
            `/bookings/${bookingId}/voucher`,
            {
                responseType: "blob"
            }
        );

        const url = window.URL.createObjectURL(
            new Blob([res.data])
        );

        const link = document.createElement("a");

        link.href = url;

        link.setAttribute(
            "download",
            `hotel-voucher-${bookingId}.pdf`
        );

        document.body.appendChild(link);

        link.click();

        window.URL.revokeObjectURL(url);

        link.remove();

    } catch (err) {

        console.error(err);

        alert(
            err?.response?.data?.message ||
            "Voucher download failed"
        );
    }
};


const handleUpdateLead = async () => {
    try {
        setSavingLead(true);

        const dests =
            Array.isArray(leadEditForm.destinations) &&
            leadEditForm.destinations.length
                ? leadEditForm.destinations
                : (
                    leadEditForm.destination
                        ? [leadEditForm.destination]
                        : []
                );

        const payload = {
            customerName: leadEditForm.customerName,
            email: leadEditForm.email,
            phone: leadEditForm.phone,
            travelDate: leadEditForm.travelDate,
            duration: Number(
                leadEditForm.duration || 0
            ),
            destinations: dests,
            destination: dests[0] || null,
            pax: {
                adults: Number(
                    leadEditForm.adults || 1
                ),
                children: Number(
                    leadEditForm.children || 0
                ),
                infants: Number(
                    leadEditForm.infants || 0
                ),
            },
        };

        await apiClient.put(
            `/leads/${leadId}`,
            payload
        );

        /*
         * Fetch the freshly updated Lead from backend.
         * This ensures destination, populated destination
         * name and destination images are current.
         */
        await fetchLeadDetails();

        setShowLeadEdit(false);

        alert("Lead updated successfully");
    } catch (err) {
        console.error(
            "Lead update failed:",
            err
        );

        alert(
            err?.response?.data?.message ||
            "Failed to update lead"
        );
    } finally {
        setSavingLead(false);
    }
};

    // ── Early returns ──────────────────────────────────────────────────────────
    if (loading) {
        return (
            <div className="trip-detail-view">
                <div className="loading">Loading trip details...</div>
            </div>
        );
    }

    if (error && !lead) {
        return (
            <div className="trip-detail-view">
                <div className="error-message">
                    <h2>Error Loading Lead</h2>
                    <p>{error}</p>
                    <button onClick={() => navigate("/leads")} className="btn btn-primary">
                        Back to Leads
                    </button>
                </div>
            </div>
        );
    }

    if (!lead) {
        return (
            <div className="trip-detail-view">
                <div className="error-message">
                    <h2>Lead Not Found</h2>
                    <p>The requested lead could not be found.</p>
                    <button onClick={() => navigate("/leads")} className="btn btn-primary">
                        Back to Leads
                    </button>
                </div>
            </div>
        );
    }

    // ── Render ─────────────────────────────────────────────────────────────────

    const btnStyle = {
        padding: "4px 8px",
        fontSize: 12,
        borderRadius: 6,
        border: "1px solid #ddd",
        cursor: "pointer",
    };

    return (
        <div className="trip-detail-view">

            {/* Header */}
            <div className="trip-header">
                <div className="header-left">
                    <button className="back-btn" onClick={() => navigate("/leads")}>
                        ← Trip Details
                    </button>
                    <div className="breadcrumb">
                        <span>Trips</span> › <span>Current</span>
                    </div>
                </div>
                <div className="header-right"></div>
            </div>

            {/* Lead Info Card */}
            <div className="rounded-3xl border border-gray-200 bg-white p-4 md:p-6 shadow-sm">
                <div className="flex flex-col gap-4 md:flex-row md:items-start md:justify-between md:gap-6">
                    <div>
                        <div className="flex items-center gap-3 flex-wrap">
                            <h1 className="text-3xl font-bold text-gray-900">
                                {lead?.customerName || "-"}
                            </h1>
                            <div className="px-3 py-1 rounded-full bg-gray-100 text-xs font-semibold text-gray-700">
                                #{lead.leadId}
                            </div>

<select
    value={lead?.status || "new"}
    onChange={async (e) => {
        try {

await apiClient.patch(
    `/leads/${leadId}/status`,
    {
        status: e.target.value,
    }
);

            await fetchLeadDetails();
        } catch (err) {
            alert("Status update failed");
        }
    }}
    className="px-3 py-1 rounded-full border border-gray-300 text-xs font-semibold"
>
<option value="new">New</option>
<option value="contacted">Contacted</option>
<option value="qualified">Qualified</option>
<option value="quoted">Quoted</option>
<option value="negotiation">Negotiation</option>
<option value="lost">Lost</option>

</select>


                        </div>

                        <div className="flex flex-wrap gap-5 mt-4 text-sm text-gray-500">

<div>
    Destinations:{" "}
    {
        (Array.isArray(lead?.destinations) && lead.destinations.length > 0)
            ? lead.destinations.map(d => d?.name || d?.city || d).join(", ")
            : (lead?.destination?.name || lead?.destinationSnapshot || "-")
    }
</div>
                            <div>
                                Travel:{" "}
                                {lead.travelDate ? new Date(lead.travelDate).toLocaleDateString() : "-"}
                            </div>

<div>
 Duration: {
   Number(lead?.duration) > 0
     ? `${lead.duration} Days`
     : "-"
 }
</div>

                            <div>Pax: {lead?.pax?.adults || 1}</div>
                            <div>Phone: {lead.phone || "-"}</div>
                        </div>


                        {/* Tags */}
                        <div className="flex flex-wrap items-center gap-2 mt-5">
                            {(lead.tags || []).length > 0 ? (
                                lead.tags.map((tag, index) => (
                                    <div key={index} className="px-3 py-1 rounded-full bg-black text-white text-xs font-medium">
                                        {tag}
                                    </div>
                                ))
                            ) : (
                                <div className="text-xs text-gray-400">No tags added</div>
                            )}
                            <button
                                onClick={async () => {
                                    const tag = prompt("Enter tag");
                                    if (!tag?.trim()) return;
                                    try {
                                        await apiClient.post(`/leads/${leadId}/tags`, { tags: [tag.trim()] });
                                        await fetchLeadDetails();
                                    } catch (err) {
                                        console.error(err);
                                        alert("Failed to add tag");
                                    }
                                }}
                                className="px-3 py-1 rounded-full border border-gray-300 text-xs font-medium hover:bg-gray-50 transition"
                            >
                                + Add Tag
                            </button>
                        </div>
                    </div>

                    {/* Right panel */}
                    <div className="w-full md:w-auto md:min-w-[220px] rounded-2xl bg-gray-50 p-4">
                        <div className="text-xs uppercase tracking-wide text-gray-400 mb-3">
                            Assigned Consultant
                        </div>

<div className="text-sm font-semibold text-gray-900">
    {
        lead?.assignedTo?.name ||
        lead?.createdBy?.name ||
        "Unassigned"
    }
</div>

<div className="mt-5 flex flex-col gap-2">

    <button
        onClick={() => {
            setLeadEditForm({
                customerName: lead?.customerName || "",
                email: lead?.email || "",
                phone: lead?.phone || "",
                travelDate: lead?.travelDate
                    ? lead.travelDate.slice(0,10)
                    : "",
                duration: lead?.duration || "",

                destination:
                    lead?.destination?._id ||
                    lead?.destination ||
                    "",

                adults: lead?.pax?.adults || 1,
                children: lead?.pax?.children || 0,
                infants: lead?.pax?.infants || 0,
            });

            setShowLeadEdit(true);
        }}
        className="w-full px-4 py-3 rounded-2xl border border-gray-300 bg-white text-sm font-medium hover:bg-gray-50 transition"
    >
        Edit Lead
    </button>

    {user && ["admin", "superadmin", "sales_manager", "team_lead"].includes(user.role) && (
        <button
            onClick={() => setShowReassignModal(true)}
            className="w-full px-4 py-3 rounded-2xl border border-purple-200 bg-purple-50 text-purple-700 text-sm font-medium hover:bg-purple-100 transition flex items-center justify-center gap-2"
        >
            Reassign Consultant
        </button>
    )}

    <button
        onClick={() => navigate(`/quotation-builder?leadId=${leadId}`)}
        className="w-full px-4 py-3 rounded-2xl bg-black text-white text-sm font-medium hover:opacity-90 transition"
    >
        + Create Quote
    </button>

</div>

                    </div>
                </div>
            </div>

            {/* Edit Lead Modal */}
            <Modal
                title="Edit Lead Details"
                open={showLeadEdit}
                onCancel={() => setShowLeadEdit(false)}
                onOk={handleUpdateLead}
                confirmLoading={savingLead}
            >
                <div style={{ display: "flex", flexDirection: "column", gap: 14 }}>
                    <input
                        placeholder="Customer Name"
                        value={leadEditForm.customerName}
                        onChange={(e) => setLeadEditForm({ ...leadEditForm, customerName: e.target.value })}
                    />
                    <input
                        placeholder="Email"
                        value={leadEditForm.email}
                        onChange={(e) => setLeadEditForm({ ...leadEditForm, email: e.target.value })}
                    />
                    <input
                        placeholder="Phone"
                        value={leadEditForm.phone}
                        onChange={(e) => setLeadEditForm({ ...leadEditForm, phone: e.target.value })}
                    />
                    <select
                        value={leadEditForm.destination}
                        onChange={(e) => setLeadEditForm({ ...leadEditForm, destination: e.target.value })}
                    >
                        <option value="">Select Destination</option>
                        {destinations.map((d) => (
                            <option key={d._id} value={d._id}>{d.name}</option>
                        ))}
                    </select>
                    <div
    style={{
        display: "grid",
        gridTemplateColumns: isMobile
            ? "1fr"
            : "repeat(3, minmax(0,1fr))",
        gap: 10,
    }}
>
                        <input
                            type="number" placeholder="Adults"
                            value={leadEditForm.adults}
                            onChange={(e) => setLeadEditForm({ ...leadEditForm, adults: e.target.value })}
                        />
                        <input
                            type="number" placeholder="Children"
                            value={leadEditForm.children}
                            onChange={(e) => setLeadEditForm({ ...leadEditForm, children: e.target.value })}
                        />
                        <input
                            type="number" placeholder="Infants"
                            value={leadEditForm.infants}
                            onChange={(e) => setLeadEditForm({ ...leadEditForm, infants: e.target.value })}
                        />
                    </div>
                    <input
                        type="date"
                        value={leadEditForm.travelDate}
                        onChange={(e) => setLeadEditForm({ ...leadEditForm, travelDate: e.target.value })}
                    />
                    <input
                        type="number" placeholder="Duration (Days)"
                        value={leadEditForm.duration || ""}
                        onChange={(e) => setLeadEditForm({ ...leadEditForm, duration: e.target.value })}
                    />
                </div>
            </Modal>

<Modal
    title="Log Payment"
    open={showPaymentModal}
    onCancel={() =>
        setShowPaymentModal(false)
    }
    onOk={handleLogPayment}
>
    <div
        style={{
            display: "flex",
            flexDirection: "column",
            gap: 12
        }}
    >

        <div>
            Quote:
            {" "}
            {selectedQuote?.quotationNumber ||
             selectedQuote?.quotationId}
        </div>

{selectedQuote?.nextInstallmentNumber ? (

    <div
        style={{
            padding: 12,
            background: "#f9fafb",
            border: "1px solid #e5e7eb",
            borderRadius: 10,
            fontWeight: 600,
        }}
    >
        Installment #
        {" "}
        {selectedQuote.nextInstallmentNumber}
    </div>

) : (

    <div
        style={{
            padding: 12,
            background: "#ecfdf5",
            border: "1px solid #86efac",
            borderRadius: 10,
            fontWeight: 600,
            color: "#166534",
        }}
    >
        ✓ Fully Paid
    </div>

)}


<input

    type="text"

    placeholder="Installment Title"

    value={installmentForm.title}

    onChange={(e)=>

        setInstallmentForm({

            ...installmentForm,

            title:e.target.value

        })

    }

/>

        <input
            type="number"
            placeholder="Amount"
            value={paymentForm.amount}
            onChange={(e) =>
                setPaymentForm({
                    ...paymentForm,
                    amount: e.target.value
                })
            }
        />

        <select
            value={paymentForm.paymentMode}
            onChange={(e) =>
                setPaymentForm({
                    ...paymentForm,
                    paymentMode: e.target.value
                })
            }
        >
            <option value="upi">UPI</option>
            <option value="cash">Cash</option>
            <option value="bank_transfer">
                Bank Transfer
            </option>
            <option value="cheque">
                Cheque
            </option>
        </select>

        <input
            placeholder="UTR Number"
            value={paymentForm.utrNumber}
            onChange={(e) =>
                setPaymentForm({
                    ...paymentForm,
                    utrNumber: e.target.value
                })
            }
        />

        <textarea
            placeholder="Comments"
            value={paymentForm.comments}
            onChange={(e) =>
                setPaymentForm({
                    ...paymentForm,
                    comments: e.target.value
                })
            }
        />

    </div>
</Modal>

<Modal

    title="Add Installment"

    open={showInstallmentModal}

    onCancel={() =>
        setShowInstallmentModal(false)
    }

    onOk={handleAddInstallment}

>

    <div
        style={{
            display: "flex",
            flexDirection: "column",
            gap: 16,
        }}
    >

<div
    style={{
        background: "#f9fafb",
        border: "1px solid #e5e7eb",
        borderRadius: 10,
        padding: 14,
        marginBottom: 16,
    }}
>
    Outstanding Balance

    <div
        style={{
            fontSize: 24,
            fontWeight: 700,
            marginTop: 6,
        }}
    >
        ₹
        {(booking?.financials?.balanceDue || 0).toLocaleString()}
    </div>
</div>

<input
    type="text"
    placeholder="Installment Name (e.g. Second Installment)"
    value={installmentForm.title}
    onChange={(e)=>
        setInstallmentForm({
            ...installmentForm,
            title:e.target.value
        })
    }
/>

        <input

            type="number"

            placeholder={`Remaining ₹${(
             booking?.financials?.balanceDue || 0
            ).toLocaleString()}`}

            value={installmentForm.amount}

            onChange={(e) =>

                setInstallmentForm({

                    ...installmentForm,

                    amount:
                        e.target.value,

                })

            }

        />

        <input

            type="date"

            value={installmentForm.dueDate}

            onChange={(e) =>

                setInstallmentForm({

                    ...installmentForm,

                    dueDate:
                        e.target.value,

                })

            }

        />

        <textarea

            placeholder="Notes"

            value={installmentForm.notes}

            onChange={(e) =>

                setInstallmentForm({

                    ...installmentForm,

                    notes:
                        e.target.value,

                })

            }

        />

    </div>

</Modal>

<Modal
    title="Edit Installment"
    open={showEditModal}
    onCancel={() =>
        setShowEditModal(false)
    }
    onOk={handleSaveInstallment}
>

<div
style={{
display:"flex",
flexDirection:"column",
gap:16
}}
>

<input
type="text"
placeholder="Installment Name"
value={editForm.title}
onChange={(e)=>
setEditForm({
...editForm,
title:e.target.value
})
}
/>

<input
type="number"
placeholder="Amount"
value={editForm.amount}
onChange={(e)=>
setEditForm({
...editForm,
amount:e.target.value
})
}
/>

<input
type="date"
value={editForm.dueDate}
onChange={(e)=>
setEditForm({
...editForm,
dueDate:e.target.value
})
}
/>

<select
value={editForm.status}
onChange={(e)=>
setEditForm({
...editForm,
status:e.target.value
})
}
>

<option value="pending">
Pending
</option>

<option value="partial">
Partial
</option>

<option value="paid">
Paid
</option>

</select>

<textarea
placeholder="Notes"
value={editForm.notes}
onChange={(e)=>
setEditForm({
...editForm,
notes:e.target.value
})
}
/>

</div>

</Modal>


            {/* Tab Navigation */}
            <div className="mb-6 flex flex-wrap gap-2 rounded-2xl border border-gray-200 bg-white p-2 shadow-sm">
                {[
                    { key: "basic", label: "Overview" },
                    { key: "quotes", label: "Quotes" },
                    { key: "bookings", label: "Services" },
                    { key: "operations", label: "Transport & Operations" },
                    { key: "payments", label: "Payments" },
                    { key: "docs", label: "Documents" },
                    { key: "activities", label: "Timeline" },
                ].map((tab) => (
                    <button
                        key={tab.key}
                        onClick={() => handleTabChange(tab.key)}
                        className={`px-4 py-2 rounded-xl text-sm font-medium transition-all duration-200 ${
                            activeTab === tab.key
                                ? "bg-black text-white shadow-sm"
                                : "text-gray-600 hover:bg-gray-100"
                        }`}
                    >
                        {tab.label}
                    </button>
                ))}
            </div>

            {/* Main Layout */}
            <div
                className="main-content-layout"
                style={{
    display: "grid",
    gridTemplateColumns: isMobile
        ? "1fr"
        : "minmax(0,1fr) 280px",
    gap: 24,
    alignItems: "start"
}}
            >
                {/* Left Content */}
                <div className="left-content">

                    {/* ── Overview Tab ─────────────────────────────────────── */}
                    {activeTab === "basic" && (
                        <div className="basic-details">
                            <h2>Basic Details</h2>
                            <div className="details-grid">
                                <div className="detail-item">
                                    <label>Trip:</label>
                                    <span>
                                        {lead?.leadId ||
                                        lead?.tripName ||
                                       "Lead Journey"}
                                  </span>
                                </div>
                                <div className="detail-item">
                                    <label>Customer:</label>
                                    <span>{lead?.customerName || booking?.customer?.name || "N/A"}</span>
                                </div>
                                <div className="detail-item">
                                    <label>Email:</label>
                                    <span>{lead?.email || booking?.customer?.email || "-"}</span>
                                </div>
                                <div className="detail-item">
                                    <label>Phone:</label>
                                    <span>{lead?.phone || booking?.customer?.phone || "-"}</span>
                                </div>
                                <div className="detail-item">
                                    <label>Status:</label>
                                    <span>{booking?.status || lead?.status || "-"}</span>
                                </div>
                                <div className="detail-item">
                                    <label>Destination:</label>
<span>
  {lead?.destination?.name ||
   lead?.destinationSnapshot ||
   (typeof lead?.destination === "string"
      ? lead.destination
      : "-")}
</span>

                                </div>
                                <div className="detail-item">
                                    <label>Travel Date:</label>
                                    <span>
                                        {lead?.travelDate
                                            ? new Date(lead.travelDate).toLocaleDateString()
                                            : booking?.departureDate
                                            ? new Date(booking.departureDate).toLocaleDateString()
                                            : "-"}
                                    </span>
                                </div>
<div className="detail-item">
    <label>Return Date:</label>
    <span>
        {lead?.returnDate
            ? new Date(lead.returnDate).toLocaleDateString()
            : booking?.returnDate
            ? new Date(booking.returnDate).toLocaleDateString()
            : "-"}
    </span>
</div>

<div className="detail-item">
    <label>Duration:</label>
    <span>
        {
            Number(
                lead?.duration ||
                booking?.duration
            ) > 0
                ? `${
                    lead?.duration ||
                    booking?.duration
                  } Days`
                : "-"
        }
    </span>
</div>

                                <div className="detail-item">
                                    <label>Revenue:</label>
<span>
 ₹{
 (
   booking?.pricing?.grandTotal ||
   booking?.pricing?.totalPrice ||
   0
 ).toLocaleString()
}
</span>

                                </div>
                            </div>
                            <div className="comments-section">
                                <h3>Comments</h3>
                                <p>
                                    {lead?.comments?.length > 0
                                        ? lead.comments[lead.comments.length - 1]?.text
                                        : booking?.notes || "No comments"}
                                </p>
                            </div>
                        </div>
                    )}

                    {/* ── Quotes Tab ───────────────────────────────────────── */}
                    {activeTab === "quotes" && (
                        <div className="quotes-section">

                            {quotesLoading ? (
                                <p>Loading quotes...</p>
                            ) : quotes.length > 0 ? (
                                <div className="existing-quotes">
                                    <h3>Existing Quotes</h3>
                                    <div className="quotes-list">
                                        {quotes.map((quote) => (
                                            <div key={quote._id} className="quote-item">
                                                <div className="quote-header">

<div>
    <h3>
        Quote #
        {quote.quotationNumber || quote.quoteNumber || "-"}
    </h3>

    <div className="text-xs text-gray-400">
        Created: {
            quote.createdAt
                ? new Date(
                      quote.createdAt
                  ).toLocaleDateString()
                : "-"
        }
    </div>

{
    quote.version && (
        <div
            className="text-xs text-gray-400"
        >
            Version: {quote.version}
        </div>
    )
}

    {
        quote.expiresAt && (
            <div
                className="text-xs mt-1"
                style={{
                    color:
                        quote.isExpired
                            ? "#dc2626"
                            : "#16a34a",
                }}
            >
                {
                    quote.isExpired
                        ? "Offer Expired"
                        : `Expires: ${new Date(
                              quote.expiresAt
                          ).toLocaleString()}`
                }
            </div>
        )
    }
</div>
                                                    <div className="flex items-center gap-2">
                                                        <button
                                                            className="px-4 py-2 rounded-xl bg-black text-white text-sm font-medium hover:opacity-90 transition"
                                                            onClick={() => navigate(`/quotation-builder/use/${quote._id}`)}
                                                        >
                                                            Use Quote
                                                        </button>
                                                        <button
                                                            className="px-4 py-2 rounded-xl border border-gray-300 bg-white text-sm font-medium hover:bg-gray-50 transition"
                                                            onClick={() => navigate(`/quotation-builder/edit/${quote._id}`)}
                                                        >
                                                            Edit Quote
                                                        </button>
                                                        <Dropdown
                                                            trigger={["click"]}

menu={{
    items: [

        {
            key: "preview",
            label: "Preview Proposal",
            onClick: () =>
                navigate(
                    `/quotation-builder/view/${quote._id}`
                ),
        },

        {
            key: "duplicate",
            label: "Duplicate Quote",
            onClick: () =>
                navigate(
                    `/quotation-builder/duplicate/${quote._id}`
                ),
        },

        {
            key: "pdf",
            label: "Download PDF",
            onClick: () =>
                handleDownloadQuote(
                    quote
                ),
        },

{
    key: "payment",
    label: "Log Payment",
    onClick: () => {

        setSelectedQuote(quote);

        setShowPaymentModal(true);
    },
},

...(quote.payment?.status === "verified" &&
!bookingId
    ? [
          {
              key: "convert",
              label: "Convert To Trip",
              onClick: () =>
                  handleConvertToBooking(
                      quote
                  ),
          },
      ]
    : []),

        { type: "divider" },

        {
            key: "archive",
            label: "Archive Quote",
            onClick: () =>
                handleArchiveQuote(
                    quote
                ),
        },

        {
            key: "cancel",
            label: "Cancel Quote",
            danger: true,
            onClick: () =>
                handleCancelQuote(
                    quote
                ),
        },

    ],
}}

                                                            
                                                        >
                                                            <button className="w-10 h-10 rounded-xl border border-gray-300 bg-white hover:bg-gray-50 transition">⋮</button>
                                                        </Dropdown>
                                                    </div>
                                                </div>
                                                <div className="quote-details">
                                                    <p>
                                                        <strong>Total:</strong> ₹
                                                        {(quote.pricingSnapshot?.grandTotal || quote.pricingSnapshot?.totalPrice || 0).toLocaleString()}
                                                    </p>
                                                    <p>
                                                        <strong>Status:</strong>
                                                        <span className={`ml-2 inline-flex items-center rounded-full px-2.5 py-1 text-xs font-semibold capitalize ${

quote.status === "sent"
    ? "bg-green-50 text-green-700 border border-green-200"
    : quote.status === "viewed"
    ? "bg-cyan-50 text-cyan-700 border border-cyan-200"
    : quote.status === "draft"
    ? "bg-gray-100 text-gray-700 border border-gray-200"
    : quote.status === "expired"
    ? "bg-yellow-50 text-yellow-700 border border-yellow-200"
    : quote.status === "cancelled"
    ? "bg-red-50 text-red-700 border border-red-200"
    : quote.status === "archived"
    ? "bg-zinc-100 text-zinc-700 border border-zinc-200"
    : quote.status === "converted"
    ? "bg-emerald-50 text-emerald-700 border border-emerald-200"
    : "bg-gray-100 text-gray-700 border border-gray-200"

                                                        }`}>
                                                            {quote.status}
                                                        </span>
                                                    </p>

<p>
    <strong>Created:</strong>{" "}
    {quote.createdAt ? new Date(quote.createdAt).toLocaleDateString() : "-"}
</p>

<p>
    <strong>Payment:</strong>

    <span
        className={`ml-2 inline-flex items-center rounded-full px-2.5 py-1 text-xs font-semibold capitalize ${
            quote.payment?.status === "verified"
                ? "bg-green-50 text-green-700 border border-green-200"
                : quote.payment?.status === "logged"
                ? "bg-blue-50 text-blue-700 border border-blue-200"
                : quote.payment?.status === "rejected"
                ? "bg-red-50 text-red-700 border border-red-200"
                : quote.payment?.status === "not_required"
                ? "bg-zinc-100 text-zinc-700 border border-zinc-200"
                : "bg-yellow-50 text-yellow-700 border border-yellow-200"
        }`}
    >
        {quote.payment?.status || "pending"}
    </span>
</p>
                                                    {quote.status === "sent" &&
                                                       quote.payment?.status === "verified" &&
                                                         !bookingId && (
                                                        <button
                                                            className="mt-3 px-4 py-2 rounded-xl bg-black text-white text-sm font-medium hover:opacity-90 transition"
                                                            onClick={() => handleConvertToBooking(quote)}
                                                        >
                                                            🚀 Convert to Trip
                                                        </button>
                                                    )}
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            ) : (
                                <div className="rounded-2xl border border-dashed border-gray-300 bg-white p-10 text-center">
                                    <div className="text-lg font-semibold text-gray-800">No quotations created yet</div>
                                    <div className="text-sm text-gray-500 mt-2">Create your first proposal for this lead</div>
                                </div>
                            )}
                        </div>
                    )}

                    {/* ── Services Tab ─────────────────────────────────────── */}
                    {activeTab === "bookings" && (
                        <div>

                        {/* LEFT — SERVICES */}
                        <div>
                        <div className="booking-item">


<h2
    style={{
        fontSize: 24,
        fontWeight: 700,
        marginBottom: 20,
        color: "#111827",
    }}
>
    Hotel Bookings
</h2>

{services.some(
    s => s.status === "changed"
) && (

<div
    className="mb-5 rounded-xl border border-yellow-300 bg-yellow-50 p-4"
>
    <div className="font-medium text-yellow-800">
        Services details are not up-to-date.
    </div>

    <div className="text-sm text-yellow-700 mt-1">
        Some hotel bookings have changed.
    </div>

</div>

)}

                            {/* Service List */}
                            {services.length === 0 ? (
                                <p style={{ color: "#999" }}>No services added yet</p>
                            ) : !bookingId ? (
                                <p style={{ color: "#999" }}>Select a trip</p>
                            ) : servicesLoading ? (
                                <p>Loading...</p>
                            ) : (
                                <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>

<div
    className="w-full rounded-xl border border-gray-200 bg-white overflow-hidden"
>
    <table className="w-full">

<thead className="bg-gray-50">
<tr>

<th className="w-[22%] p-4 text-left">
    Hotel
</th>

<th className="w-[28%] p-4 text-left">
    Stay & Services
</th>

<th className="w-[22%] p-4 text-left">
    Status
</th>

<th className="w-[18%] p-4 text-left">
    Tag/Comments
</th>

<th className="w-[10%] p-4 text-right">
    Price
</th>

</tr>
</thead>

        <tbody>

            {services.map((s) => (

                <tr
                    key={s._id}
                    className="border-t"
                >

                    <td className="p-3">

<div className="font-semibold text-[18px] text-[#0d6b63]">
    {s.hotelName || s.title}
</div>

<div className="text-sm text-gray-500 mt-1">
    {s.location?.city || "-"}
</div>


                    </td>

                    <td className="p-3">

                        <div>
                            {new Date(
                                s.checkIn ||
                                s.startDate
                            ).toLocaleDateString()}

                            {" - "}

                            {new Date(
                                s.checkOut ||
                                s.endDate
                            ).toLocaleDateString()}
                        </div>

<div className="text-xs text-gray-500 mt-2">
    {s.mealPlan ||  "-"}
</div>

<div className="text-xs text-gray-400">
    {s.roomType || "-"}
</div>

                    </td>

<td className="p-3">

    {s.status === "confirmed" ? (

        <div>

            <div className="font-semibold text-green-700">
                ✓ Confirmed
            </div>

            <div className="text-xs text-gray-500">
                Hotel Reserved
            </div>

            <button
                className="text-[#b36b00] text-sm mt-2"
                onClick={generateServiceVoucher}
            >
                Generate Voucher
            </button>

        </div>

    ) : s.status === "changed" ? (

        <div>

            <div className="font-semibold text-amber-600">
                Changed
            </div>

            <div className="text-xs text-gray-500">
                Hotel Changed
            </div>

        </div>

    ) : s.status === "in_progress" ? (

        <div>

            <div className="font-semibold text-blue-600">
                In Progress
            </div>

        </div>

    ) : (

        <div>

            <div className="font-semibold text-gray-600">
                Initialized
            </div>

        </div>

    )}

</td>


<td className="p-3">

    <div className="text-sm text-gray-700">
        {
            s.comments ||
            s.comment ||
            s.remarks ||
            s.note ||
            s.changeReason ||
            "-"
        }
    </div>

</td>

<td className="p-3 text-right font-semibold">

    ₹ {
        (
            s.pricing?.finalPrice ||
            s.pricing?.cost ||
            0
        ).toLocaleString()
    }

</td>

                </tr>

            ))}

        </tbody>

    </table>
</div>


                                </div>
                            )}

                        </div>

                     </div>

                   </div>
                )}

                    {/* ── Transport & Operations Tab ─────────────────────── */}
                    {activeTab === "operations" && (
                        <TripTransportOperations
                            booking={booking}
                            lead={lead}
                            services={services}
                            bookingId={bookingId}
                            onRefreshBooking={refreshBooking}
                        />
                    )}

{/* ── Payments Tab ───────────────────────────────────── */}
{activeTab === "payments" && (
    <div className="accounting-section">

{/* PAYMENT SCHEDULE */}

        <div
            style={{
                background: "#fff",
                border: "1px solid #e5e7eb",
                borderRadius: 12,
                padding: 20,
                marginBottom: 20,
            }}
        >

            <div
                style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    marginBottom: 16,
                }}
            >

                <h3 style={{ margin: 0 }}>
                    Payment Schedule
                </h3>

<div
    style={{
        display: "flex",
        gap: 30,
        margin: "16px 0 22px",
        flexWrap: "wrap",
    }}
>

<div>

<div
style={{
fontSize:12,
color:"#666"
}}
>
Total
</div>

<div
style={{
fontWeight:700,
fontSize:22
}}
>
₹{(
booking?.computedFinancials?.grandTotal || 0
).toLocaleString()}
</div>

</div>

<div>

<div
style={{
fontSize:12,
color:"#666"
}}
>
Received
</div>

<div
style={{
fontWeight:700,
fontSize:22,
color:"#16a34a"
}}
>
₹{(
booking?.financials?.totalPaid || 0
).toLocaleString()}
</div>

</div>

<div>

<div
style={{
fontSize:12,
color:"#666"
}}
>
Outstanding
</div>

<div
style={{
fontWeight:700,
fontSize:22,
color:"#dc2626"
}}
>
₹{(
booking?.financials?.balanceDue || 0
).toLocaleString()}
</div>

</div>

</div>

{
booking?.financials?.paymentStatus !== "paid"
&&

<button
onClick={()=>
setShowInstallmentModal(true)
}
>

+ Add Installment

</button>

}

            </div>

{booking?.paymentSchedule?.length ? (

<table
    style={{
        width: "100%",
        borderCollapse: "collapse",
    }}
>

<thead>

<tr
style={{
background:"#f9fafb"
}}
>

<th align="left">Installment</th>

<th align="left">Due Date</th>

<th align="right">Amount</th>

<th align="center">Status</th>

<th align="left">Notes</th>

<th align="right">Action</th>

</tr>

</thead>

<tbody>

{booking.paymentSchedule.map((item)=>(

<tr
key={item._id}
style={{
borderBottom:"1px solid #eee"
}}
>

<td
style={{
padding:"12px 8px"
}}
>

{item.title ||
`Installment ${item.installmentNumber}`}

</td>

<td>

{
item.dueDate
?
new Date(item.dueDate).toLocaleDateString()
:
"-"
}

</td>

<td align="right">

₹{
Number(item.amount||0).toLocaleString()
}

</td>

<td align="center">

<span
style={{

display:"inline-block",

padding:"5px 12px",

borderRadius:999,

fontSize:12,

fontWeight:600,

background:

item.status==="paid"

? "#dcfce7"

: item.status==="partial"

? "#dbeafe"

: "#fef3c7",

color:

item.status==="paid"

? "#166534"

: item.status==="partial"

? "#1d4ed8"

: "#92400e"

}}
>

{
item.status==="paid"

? "Paid"

: item.status==="partial"

? "Partial"

: "Pending"

}

</span>

</td>

<td>

{item.notes || "-"}

</td>

<td align="right">

<button
style={{
padding:"6px 10px",
marginRight:8,
border:"1px solid #d1d5db",
borderRadius:8,
cursor:"pointer"
}}
onClick={()=>
handleEditInstallment(item)
}
>

✏ Edit

</button>

<button
style={{
padding:"6px 10px",
border:"1px solid #fecaca",
background:"#fef2f2",
color:"#dc2626",
borderRadius:8,
cursor:"pointer"
}}
onClick={()=>
handleDeleteInstallment(item)
}
>

🗑 Delete

</button>

</td>

</tr>

))}

</tbody>

</table>

) : (

<div
style={{
color:"#888"
}}
>

No installments created yet.

</div>

)}


        </div>

<Accounting
    leadId={leadId}
    bookingId={booking?._id}
/>
    </div>
)}


                    {/* ── Documents Tab ────────────────────────────────────── */}
                    {activeTab === "docs" && (
                        <div className="docs-section">
                            <h2>Documents</h2>
                            {documentsLoading ? (
                                <p>Loading documents...</p>
                            ) : documents.length > 0 ? (
                                <div className="documents-list">
                                    {documents.map((doc) => (
                                        <div key={doc._id} className="document-item">
                                            <h3>{doc.name}</h3>
                                            <p><strong>Type:</strong> {doc.type}</p>
                                            <p>
                                                <strong>Uploaded:</strong>{" "}
                                                {new Date(doc.uploadedAt).toLocaleDateString()}
                                            </p>
                                            <a href={doc.url} target="_blank" rel="noopener noreferrer">
                                                View Document
                                            </a>
                                        </div>
                                    ))}
                                </div>
                            ) : (
                                <p>No documents found for this lead.</p>
                            )}
                            <button className="btn btn-primary">Upload Document</button>
                        </div>
                    )}

                    {/* ── Activities Tab ───────────────────────────────────── */}
                    {activeTab === "activities" && (
                        <div className="rounded-2xl border border-gray-200 bg-white p-6">
                            <div className="flex items-center justify-between mb-6">
                                <div>
                                    <h2 className="text-xl font-semibold text-gray-900">Activity Timeline</h2>
                                    <p className="text-sm text-gray-500 mt-1">
                                        Follow ups, operational notes and customer interactions
                                    </p>
                                </div>
                                <button
                                    type="button"
                                    disabled={creatingActivity}
                                    onClick={handleAddActivity}
                                    className="px-4 py-2 rounded-xl bg-black text-white text-sm font-medium hover:opacity-90 transition"
                                >
                                    {creatingActivity ? "Adding..." : "+ Follow Up"}
                                </button>
                            </div>

                            {activitiesLoading ? (
                                <p>Loading activities...</p>
                            ) : activities.length > 0 ? (
                                <div className="space-y-5">
                                    {activities.map((activity) => (
                                        <div key={activity._id} className="relative pl-6 pb-5 border-l border-gray-200">
                                            <div className="absolute -left-[7px] top-1 w-3 h-3 rounded-full bg-black"></div>
                                            <div className="flex items-center justify-between">
                                                <div className="text-sm font-semibold text-gray-900 capitalize">
                                                    {activity.type?.replaceAll("_", " ")}
                                                </div>
                                                <div className="text-xs text-gray-400">
                                                    {new Date(activity.createdAt).toLocaleString()}
                                                </div>
                                            </div>
                                            <div className="mt-2 text-sm text-gray-600 leading-6">
                                                {activity.message || activity.description}
                                            </div>
                                            <div className="mt-3 flex items-center gap-2">
                                                <div className="px-2 py-1 rounded-full bg-gray-100 text-xs text-gray-700">
                                                    {activity.createdBy?.name || "System"}
                                                </div>
                                                <div className="px-2 py-1 rounded-full bg-blue-50 text-xs text-blue-700">
                                                    CRM Activity
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            ) : (
                                <div className="rounded-2xl border border-dashed border-gray-300 p-10 text-center">
                                    <div className="text-lg font-semibold text-gray-800">No activities yet</div>
                                    <div className="text-sm text-gray-500 mt-2">
                                        Add follow ups and operational notes to track this lead
                                    </div>
                                </div>
                            )}
                 
                          </div>
                    )}


                  </div>

                {/* End left-content */}

                {/* Right Sidebar */}
                <div className="right-sidebar" style={{ position: "sticky", top: 90, height: "fit-content" }}>

                    <div className="tasks-comments-section">
                        <h3>Tasks &amp; Comments</h3>
                        <div className="space-y-4 mt-4">

                            {/* Next Follow Up */}
<div className="rounded-2xl border border-gray-200 bg-white p-4">
    <div className="text-xs uppercase tracking-wide text-gray-400 mb-2">
        Next Follow Up
    </div>

    <div className="text-sm font-semibold text-gray-900">
        {lead?.lastFollowUp?.notes || "No follow up scheduled"}
    </div>

    <div className="text-xs text-gray-500 mt-2">
        {lead?.lastFollowUp?.nextFollowUp
            ? `Scheduled: ${new Date(
                  lead.lastFollowUp.nextFollowUp
              ).toLocaleDateString()}`
            : ""}
    </div>

    <div className="text-xs text-gray-400 mt-1">
        {lead?.lastFollowUp?.date
            ? `Last Updated: ${new Date(
                  lead.lastFollowUp.date
              ).toLocaleString()}`
            : ""}
    </div>

    <button
        onClick={handleAddActivity}
        className="mt-4 w-full px-3 py-2 rounded-xl bg-black text-white text-sm font-medium hover:opacity-90 transition"
    >
        + Add Follow Up
    </button>
</div>


                            {/* Lead Status */}
                            <div className="rounded-2xl border border-gray-200 bg-white p-4">
                                <div className="text-xs uppercase tracking-wide text-gray-400 mb-2">Lead Status</div>
                                <div className="flex items-center justify-between">
                                    <div className="text-sm font-semibold text-gray-900 capitalize">{lead?.status || "New"}</div>
                                    <div className="px-2 py-1 rounded-full bg-green-50 text-green-700 text-xs">Active</div>
                                </div>
                            </div>

                            {/* Customer Info */}
                            <div className="rounded-2xl border border-gray-200 bg-white p-4">
                                <div className="text-xs uppercase tracking-wide text-gray-400 mb-3">Customer</div>
                                <div className="space-y-3">
                                    <div>
                                        <div className="text-xs text-gray-500">Phone</div>
                                        <div className="text-sm font-medium text-gray-900">{lead?.phone || "-"}</div>
                                    </div>
                                    <div>
                                        <div className="text-xs text-gray-500">Email</div>
                                        <div className="text-sm font-medium text-gray-900">{lead?.email || "-"}</div>
                                    </div>
                                    <div>
                                        <div className="text-xs text-gray-500">Travel Date</div>
                                        <div className="text-sm font-medium text-gray-900">
                                            {lead?.travelDate ? new Date(lead.travelDate).toLocaleDateString() : "-"}
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
                {/* End right-sidebar */}

            </div>
 
<AddFollowUpModal
    visible={followUpModalOpen}
    onClose={() => setFollowUpModalOpen(false)}
    leadId={leadId}
    customerName={lead?.customerName}
    onSuccess={() => {
        fetchLeadDetails();
        fetchActivities();
    }}
/>

<ReassignQueryModal
    visible={showReassignModal}
    onClose={() => setShowReassignModal(false)}
    selectedQueries={lead ? [lead] : []}
    onSuccess={() => {
        setShowReassignModal(false);
        fetchLeadDetails();
    }}
/>

{suggestedQuotes.length > 0 && (
    <div
        style={{
            marginTop: 40,
            paddingTop: 24,
            borderTop: "1px solid #e5e7eb",
        }}
    >
        <SuggestedQuotesSection
            quotes={suggestedQuotes}
            destinationName={
                lead?.destinationSnapshot ||
                lead?.destination?.name ||
                ""
            }
            onUseQuote={(q) =>
                navigate(
                    `/quotation-builder/use/${q._id}?leadId=${leadId}`
                )
            }
        />
    </div>
)}
       
               {/* End main-content-layout */}
       
        </div>

    );
};

export default TripDetailView;

